<mat-table #table [dataSource]="dataSource" id="tblFRMAStudentLunchStatus">

    <ng-container matColumnDef="Student">
        <mat-header-cell *matHeaderCellDef> 
            <span translate>Student</span> 
        </mat-header-cell>
        <mat-cell *matCellDef="let element"> 
            <!--ONE-15771 <student-name [firstName]="element.FirstName" [lastName]='element.LastName'
                [middleName]='element.MiddleName' [nickName]="element.NickName"></student-name>  -->
            {{getStudentName(element)}}
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Status">
        <mat-header-cell *matHeaderCellDef> 
            <span translate>Current Status</span> 
        </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.LunchCode}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Expires">
        <mat-header-cell *matHeaderCellDef> 
            <span translate>Expires</span> 
        </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.Expires | date: 'MM/dd/yy'}} </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: columnsToDisplay; let i = renderIndex;" id="tblFRMAStudentLunchStatusDataRow{{i}}" style="min-height: 30px;">
    </mat-row>

</mat-table>